/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(function(){
          var windowHeight, footerHeight, bodyHeight;

          function footerInit() {
            windowHeight = $(window).height();
            footerHeight = $('#footer').outerHeight();
            bodyHeight = $('body').outerHeight();
            // debug
            // console.log('Window Height = '+windowHeight+'px'+'\n'+'Footer Height = '+footerHeight+'px\n'+'Body Height = '+bodyHeight+'px');
            // set footer
            if(bodyHeight < windowHeight){
              $('.wrap').css('height', windowHeight - footerHeight );
            }
          }

          $(window).on('resize', footerInit );
          $(document).ready(footerInit);
        });


        $(function(){ // hide/show nav on scroll
          var didScroll;
          var lastScrollTop = 0;
          var delta = 5;
          var navbarHeight = $('header.navbar').outerHeight();
          // on scroll, let the interval function know the user has scrolled
          $(window).scroll(function(event){
            didScroll = true;
          });
          // run hasScrolled() and reset didScroll status
          setInterval(function() {
            if (didScroll) {
              hasScrolled();
              didScroll = false;
            }
          }, 250);
          function hasScrolled() {
            var st = $(this).scrollTop();
            if (Math.abs(lastScrollTop - st) <= delta)
              return;
              // If current position > last position AND scrolled past navbar...
            if (st > lastScrollTop && st > navbarHeight){
              // Scroll Down
              $('header.navbar > div').removeClass('nav-down').addClass('nav-up');
            } else {
              // Scroll Up
              // If did not scroll past the document (possible on mac)...
              if(st + $(window).height() < $(document).height()) {
                $('header.navbar > div').removeClass('nav-up').addClass('nav-down');
              }
            }
            lastScrollTop = st;
          }
        })

        $(function(){// The search form
          $('.navbar-form.search-form').hover(function(){
            $(this).addClass('open');
            $('.navbar-nav').addClass('search-open');
          },function(){
            if(!$('.navbar-form .search-field').is(':focus')){
              $('.navbar-form.search-form').removeClass('open');
              $('.navbar-nav').removeClass('search-open');
            }
          });

          $('.navbar-form .search-field').focus(function(){
            $('.navbar-nav').addClass('search-open');
          });
          $('.navbar-form .search-field').blur(function(){
            $('.navbar-nav').removeClass('search-open');
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        // JavaScript to be fired on the home page
        function testimonialNormalizeHeight() {

          var carousel = $('.carousel.l7-normalize-height');
          var slideHeights = [];

          if( carousel ) {

            var maxHeight;

            carousel.find('.item').each(function(i){
              slideHeights.push($(this).outerHeight());
            });

            maxHeight = Math.max.apply(Math, slideHeights);

            if( Number.isInteger(maxHeight) ) {
              carousel.find('.carousel-inner').each(function(){
                $(this).css('height', maxHeight+'px');
              });
            }
          }
        }
        testimonialNormalizeHeight();
        $(window).resize(testimonialNormalizeHeight);
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'styleguide': {
      init: function(){
        $(function () {
          $('[data-toggle="popover"]').popover();
          $('[data-toggle="tooltip"]').tooltip();
        });
      }
    },
    // Courses page (Learndash courses, not WooCommerce)
    'courses': {
      init: function() {
        $(window).load(function(){

          function ld_course_grid_resize() {
        		var last_position = {left: 0, top: 0}, last_item = null;
        		var row_items = [];
        		var row_idx = 0;
        		row_items[row_idx] = [];

        		// We first loop over the row items to setup a multidimenion array by rows.
        		$(".ld_course_grid").each(function (i, v) {

        			var item = $(v);
        			var item_position = item.position();

        			// The outer <div> element we wrap on the grid items should NOT have a locally defined style attribute
        			// If it is there we want to remove it to force the correct height calculations
        			var attr_style = item.attr('style');
        			if (attr_style != '') {
        				item.removeAttr('style');
        			}

        			if ( (last_position.left != 0 ) && ( item_position.left <= last_position.left ) ) {
        				row_idx += 1;
        				row_items[row_idx] = [];
        			}
        			row_items[row_idx].push(item);

        			last_position = item_position;
        			last_item = item;
        		});

        		// One we have the rows and related items we loop over each row
        		for (var row_idx = 0; row_idx < row_items.length; row_idx++ ) {
        		    var row = row_items[row_idx];

        			// and determine the tallest row item...
        			var row_max_height = 0;
        		    for (var item_idx = 0; item_idx < row.length; item_idx++ ) {
        		        var item = row[item_idx];

        				item_height = item.height();
        				if ( item_height > row_max_height )
        					row_max_height = item_height;
        		    }

        			// Then loop over the rows again to set the height per the tallest item in the row.
        		    for (var item_idx = 0; item_idx < row.length; item_idx++) {
        		        var item = row[item_idx];
        				item.height(row_max_height);
        			}
        		}

        	}
        	ld_course_grid_resize();
        	$(window).resize(function() {
        		ld_course_grid_resize();
        	});

        	function learndash_course_grid_course_edit_page_javascript() {
        		$("select[name=sfwd-courses_course_price_type]").change(function(){
        			var price_type = 	$("select[name=sfwd-courses_course_price_type]").val();
        			if(price_type == "closed")
        				$("#sfwd-courses_course_price").show();
        		});
        		$("select[name=sfwd-courses_course_price_type]").change();
        	}
        	if($(".sfwd-courses_settings").length)
        	setTimeout( function() {learndash_course_grid_course_edit_page_javascript();}, 1000);
        });

      }// end courses init
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
